import { FIELDERS_BOM_JOBS, FIELDERS_ENGLOAD_JOBS, LYSAGHT_BOM_JOBS, LYSAGHT_ENGLOAD_JOBS } from "./Helpers/bomJobs";
import { API_BASE } from "../AppConfig";
import * as COMMON from "../components/Common";
import { fetchTimeout } from "../components/Common";
import _merge from "lodash/merge";
import _cloneDeep from "lodash/cloneDeep";
import { appendBOMItems, newDefaultJobState } from "../redux_store/jobState";
import * as JOBSTATE_VALIDATION from "../redux_store/jobState_Validation";
const { convertJobStateToIni } = require("../components/Common_Conversions");

// return the old lysaght bom for job
export const getLysaghtJobOldBom = ({ jobId }) => {
    return LYSAGHT_BOM_JOBS[jobId];
};

// return the old fielders bom for job
export const getFieldersJobOldBom = ({ jobId }) => {
    return FIELDERS_BOM_JOBS[jobId];
};

export const GetTestConfig = async ({ brand }) => {
    let api_url = API_BASE() + "/config/";

    if (brand === "lysaght") {
        api_url += "ZGllZ28ucG9ydGVsYUBibHVlc2NvcGVzdGVlbC5jb20ubGxkLmJiY2NvbW1z";
    } else {
        api_url += "ZGllZ28ucG9ydGVsYUBibHVlc2NvcGVzdGVlbC5jb20uY2VuLmJiY2NvbW1z";
    }

    try {
        const response = await fetchTimeout(
            api_url,
            {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
            },
            45000
        );

        const json = await response.json();
        return json;
    } catch (e) {
        console.log("ERROR LOADING CONFIG", e);
        return false;
    }
};

// Gets the old job eng load
export const getFieldersOldJobLoad = ({ jobId }) => {
    return FIELDERS_ENGLOAD_JOBS[jobId];
};

// Gets the old job eng load
export const getLysaghtOldJobLoad = ({ jobId }) => {
    return LYSAGHT_ENGLOAD_JOBS[jobId];
};

// Gets the job data
export const getJob = async ({ jobId, config, app, user_data }) => {
    let job_url = API_BASE() + "job/" + "DES" + "/" + jobId + "/";
    try {
        const response = await fetchTimeout(
            job_url,
            {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
            },
            45000
        );

        let documents = JSON.parse(await response.text());
        if (documents.length > 0) {
            let recall_job_data = { ...documents[0] };
            let region = recall_job_data?.Distributor?.Offer?.Regions?.[0];

            if (region && config) {
                let region_offering = recall_job_data?.Distributor?.Offer?.offerings?.[region];
                if (region_offering) {
                    config = COMMON.mergeDeep({ ...config }, region_offering);
                    let brand = recall_job_data?.Distributor?.Offer?.Brand;
                    let new_app_offering = { ...app.offerings };
                    new_app_offering[brand].Regions[region] = region_offering;
                }
            }

            let num_areas = recall_job_data?.AreaSpecifications.length;

            let user_data_for_validation = user_data;
            if (recall_job_data?.User) user_data_for_validation = recall_job_data?.User;
            if (!user_data_for_validation?.BusinessDetails && recall_job_data?.Distributor)
                user_data_for_validation.BusinessDetails = recall_job_data?.Distributor;

            let job_to_load = _cloneDeep(
                newDefaultJobState(config, "", user_data_for_validation, num_areas ? num_areas : 1)
            );
            _merge(job_to_load, recall_job_data);

            window.svg = null;
            window.svg_data = null;
            job_to_load.App = {
                current_SVG: "",
                current_OBJ: "",
                temp_POA: "",
            };
            if (job_to_load?.QuoteParameters?.BOM?.bomHashCode) job_to_load.QuoteParameters.BOM.bomHashCode = 0;

            if (config?.region?.id === region ? config : null)
                job_to_load = JOBSTATE_VALIDATION.validateFullJob(config, job_to_load, -1, app);

            return job_to_load;
        } else {
            throw new Error("No Job");
        }
    } catch (e) {
        console.log("ERROR LOADING JOB", e);
        return false;
    }
};

// Get the latest bom from engineering
export const getJobBom = async ({ job_data, jobId, config, app }) => {
    let api_url = API_BASE() + "bom/" + jobId + "/";

    let job_ini = convertJobStateToIni(job_data, app, "", config);
    let request_id = Date.now();

    let pricefile = app?.pricefile;

    let fast = true;
    let append_items = appendBOMItems(job_data, pricefile);
    let timeout = 20000;
    if (job_data?.DesignParameters) {
        timeout =
            8000 +
            job_data.DesignParameters.NumFlat * 3000 +
            job_data.DesignParameters.NumGable * 4000 +
            job_data.DesignParameters.NumDeck * 3000;
    }

    let job_shape_details = {};
    let offering_bom_schema = {};
    offering_bom_schema.overall = config?.bom_items_for_each_job;
    for (let this_area_data of job_data.AreaSpecifications) {
        let design_option = config?.design_options?.[this_area_data.SHAPE.DesignType];
        offering_bom_schema[this_area_data.AreaIndex] = design_option?.bom_items;
        // Only requires if it's a gable structure for sheet modification (sheet laying rules for GS1)
        let isGable = this_area_data.SHAPE.RoofType1 === "Gable" ? true : false;
        job_shape_details[this_area_data.AreaIndex] = { isGable, SKYLIGHTS: this_area_data.SKYLIGHTS };
    }

    try {
        const response = await fetchTimeout(
            api_url,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    job: job_ini,
                    fast: fast,
                    order_list: {},
                    request_id: request_id,
                    job_id: jobId,
                    job_shape_details,
                    site_poa: job_data?.App?.temp_POA
                        ? job_data?.App?.temp_POA
                        : job_data?.Distributor?.Offer?.Regions?.[0],
                    offering_bom_schema: offering_bom_schema,
                    append_items: append_items,
                }),
                retry: true,
                retry_timeout: timeout * 1.5,
                request_id: request_id,
            },
            timeout
        );

        const json = await response.json();
        console.log(json);

        if (json.Error) {
            throw json.Error;
        } else if (json.bom_system) {
            return json;
        } else {
            // Handle other cases if needed
            // You can return something else or throw an error
        }
    } catch (e) {
        console.log("ERROR", e);
        // Handle errors
        // You can return an error object or rethrow the error if needed
    }
};

// Get the latest job engineering
export const getJobEngineering = async ({ job_data, jobId, config, app }) => {
    let api_url = API_BASE() + "svg/" + jobId + "/engineering";
    let user_id = app.user.id;
    let request_id = Date.now();
    let job_ini = convertJobStateToIni(job_data, app, "", config);
    let brand = job_data.Distributor.Brand;

    let timeout = 30000;
    if (job_data?.DesignParameters) {
        timeout =
            6000 +
            job_data.DesignParameters.NumFlat * 2000 +
            job_data.DesignParameters.NumGable * 3000 +
            job_data.DesignParameters.NumDeck * 2000;
    }

    if (api_url.includes("/engineering")) {
        timeout = timeout * 1.8;
    }

    try {
        const response = await fetchTimeout(
            api_url,
            {
                signal: window?.loading2d_controller?.signal,
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: user_id,
                    job_id: job_data.id,
                    request_id: request_id,
                    job: job_ini,
                    wind_data: job_data?.SiteParameters?.WindData,
                    area_index: -1,
                    session_id: window?.session_id,
                    business_code: job_data?.BusinessCode,
                    brand,
                    threed: false,
                }),
                retry: true,
                retry_timeout: timeout * 2,
                request_id: request_id,
            },
            timeout
        );

        if (response === undefined) {
            return false;
        }

        let json = await response.json();

        if (json.Error) {
            // Handle errors here if needed
        }

        // Remove the svg_data property from the JSON response
        delete json.svg_data;

        return json;
    } catch (e) {
        if (e?.message?.includes && e.message.includes("aborted")) {
            console.log("ABORTED", e.message);
            return false;
        }
        window.loading2d = false;
        console.log("ERROR", e.message);

        let message = "Error loading layout from QikQuote server.";
        if (typeof e === "string") message = e;
        if (e.message === "failed to fetch")
            message = "SERVER NOT REACHABLE. Check internet connection, then try again in a few minutes...";

        // Handle errors here if needed

        return false;
    }
};

// Get the lld test jobs list
export const getLysaghtJobList = (jobs) => {
    return Object.keys(LYSAGHT_BOM_JOBS);
};

// Get the cds test jobs list
export const getFieldersJobList = (jobs) => {
    return Object.keys(FIELDERS_BOM_JOBS);
};
